export const StaticImagePreview = ({
  label,
  summary_entry_id
}) => {
  return <div className="static-image--field non-input-label-wrapper">
      <label className="non-input-label">{label}</label>
      {summary_entry_id && <>
          <img src={`/reference_images/${summary_entry_id}`} alt={`An image of ${label}`} />
        </>}
    </div>;
};